import { useLocation } from 'react-router-dom';
import { matchPath } from 'react-router-dom';

// ----------------------------------------------------------------------

export function useActiveLink(path, deep = true) {
  const { pathname } = useLocation();

  const checkPath = path.startsWith('#');

  const currentPath = path === '/' ? '/' : `${path}`;

  const normalActive = path ? !!matchPath({ path: currentPath, end: !deep }, pathname) : false;

  const deepActive = path ? !!matchPath({ path: currentPath, end: false }, pathname) : false;

  return {
    active: deep ? deepActive : normalActive,
    isExternalLink: checkPath,
  };
} 
